export function normalizeSessionFailureCode(code: string) {
  return code
    .replace(/^functions[/-]/iu, '')
    .replaceAll('_', '-')
    .toUpperCase();
}

export function sessionSecurityFailureCopy(code: string): { title: string; detail: string } | null {
  const normalized = normalizeSessionFailureCode(code);
  if (!normalized.startsWith('APPCHECK/') && normalized !== 'IDENTITY-APP-CHECK-UNAVAILABLE') return null;
  if (normalized === 'APPCHECK/SCRIPT-UNAVAILABLE') return {
    title: '접속 확인에 필요한 파일을 불러오지 못했습니다.',
    detail: '두 연결 경로에서 파일을 불러오지 못했습니다. 네트워크 연결을 확인한 후 다시 시도해 주세요. 회사 PC에서만 반복되면 외부 연결 허용 설정을 확인해 주세요.',
  };
  if (['APPCHECK/FETCH-NETWORK-ERROR','APPCHECK/NETWORK-REQUEST-FAILED'].includes(normalized)) return {
    title: '접속 확인 중 연결이 끊겼습니다.',
    detail: '자동으로 다시 연결했지만 확인을 마치지 못했습니다. 연결 상태를 확인한 후 다시 시도해 주세요.',
  };
  if (['APPCHECK/THROTTLED','APPCHECK/INITIAL-THROTTLE','APPCHECK/RATE-LIMITED'].includes(normalized)) return {
    title: '접속 확인이 일시적으로 제한되었습니다.',
    detail: '잠시 후 다시 시도해 주세요. 새로고침을 반복해도 계속되면 운영 담당자에게 알려 주세요. 계정 사용 중지 안내와는 별개입니다.',
  };
  if (normalized === 'APPCHECK/CONFIGURATION-ERROR' || normalized === 'IDENTITY-APP-CHECK-UNAVAILABLE') return {
    title: '접속 확인 설정을 확인해야 합니다.',
    detail: '접속 확인을 준비하지 못했습니다. 운영 담당자에게 알려 주세요.',
  };
  if (normalized === 'APPCHECK/VERIFICATION-REJECTED') return {
    title: '접속 보안 확인을 통과하지 못했습니다.',
    detail: '접속 확인 요청이 거절되었습니다. 계정 사용 중지 안내와는 별개입니다. 다시 시도해도 같으면 운영 담당자에게 알려 주세요.',
  };
  if (normalized === 'APPCHECK/SERVICE-UNAVAILABLE') return {
    title: '접속 확인 서비스의 응답이 지연되고 있습니다.',
    detail: '자동으로 다시 확인했지만 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.',
  };
  return { title: '브라우저 보안 확인을 완료하지 못했습니다.', detail: '접속 확인을 마치지 못했습니다. 다시 시도해도 같으면 운영 담당자에게 알려 주세요. 계정 차단 여부와는 별개입니다.' };
}
